module.exports = __webpack_public_path__ + "img/lhb.13cb6b2f.svg";